import { updateAddressSchema } from '@/common'
import { z } from 'zod'

export const organizationAddressSchema = z.object({
  street: z.string().max(70).optional().or(z.literal('')),
  street2: z.string().max(70).optional().or(z.literal('')),
  streetNumber: z.string().max(35).optional().or(z.literal('')),
  subDivision: z.string().optional().or(z.literal('')),
  country: z.string().length(2).toLowerCase().optional(),
  postCode: z.string().max(17).optional().or(z.literal('')),
  poBox: z.string().max(70).optional().or(z.literal('')),
  city: z.string().max(35).optional().or(z.literal(''))
})

const organizationInfoFields = {
  name: z.string().min(2),
  placeOfRegistration: z.string().min(2).max(2)
}

const organizationContactFields = {
  contactFullName: z.string().min(2).or(z.literal('')),
  contactPhoneNumber: z.string().or(z.literal('')),
  contactEmail: z.email().or(z.literal('')),
  contactRole: z.string().or(z.literal(''))
}

const organizationInfoSchema = z.object(organizationInfoFields)
export const organizationDetailsSchema = z.object(organizationInfoSchema.shape)
export const organizationContactSchema = z.object(organizationContactFields)

export type OrganizationAddress = z.infer<typeof organizationAddressSchema>
export type OrganizationDetails = z.infer<typeof organizationDetailsSchema>
export type OrganizationContactDetails = z.infer<typeof organizationContactSchema>

export const organizationUpdateSchema = updateAddressSchema
  .and(organizationContactSchema.partial())
  .and(z.object({ name: z.string().min(2).optional() }))

export type OrganizationUpdatePayload = z.infer<typeof organizationUpdateSchema>

export type Organization = OrganizationDetails &
  OrganizationContactDetails &
  OrganizationAddress & {
    id: string
    createdAt: string
    updatedAt: string
  }
